/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BookingBaseService } from '../booking-base-service';
import { BookingApiConfiguration } from '../booking-api-configuration';
import { BookingStrictHttpResponse } from '../booking-strict-http-response';

import { apiMedicalAdvisorBookingDetailUrnBookingIdGet } from '../fn/medical-advisor/api-medical-advisor-booking-detail-urn-booking-id-get';
import { ApiMedicalAdvisorBookingDetailUrnBookingIdGet$Params } from '../fn/medical-advisor/api-medical-advisor-booking-detail-urn-booking-id-get';
import { apiMedicalAdvisorCancelBookingPost } from '../fn/medical-advisor/api-medical-advisor-cancel-booking-post';
import { ApiMedicalAdvisorCancelBookingPost$Params } from '../fn/medical-advisor/api-medical-advisor-cancel-booking-post';
import { apiMedicalAdvisorConfirmBookingPost } from '../fn/medical-advisor/api-medical-advisor-confirm-booking-post';
import { ApiMedicalAdvisorConfirmBookingPost$Params } from '../fn/medical-advisor/api-medical-advisor-confirm-booking-post';
import { apiMedicalAdvisorConfirmReservationConfirmReservationPost } from '../fn/medical-advisor/api-medical-advisor-confirm-reservation-confirm-reservation-post';
import { ApiMedicalAdvisorConfirmReservationConfirmReservationPost$Params } from '../fn/medical-advisor/api-medical-advisor-confirm-reservation-confirm-reservation-post';
import { apiMedicalAdvisorRequestReservationPost } from '../fn/medical-advisor/api-medical-advisor-request-reservation-post';
import { ApiMedicalAdvisorRequestReservationPost$Params } from '../fn/medical-advisor/api-medical-advisor-request-reservation-post';
import { MedicalAdvisorBookingDetailModel } from '../models/medical-advisor-booking-detail-model';

@Injectable({ providedIn: 'root' })
export class BookingMedicalAdvisorService extends BookingBaseService {
  constructor(config: BookingApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMedicalAdvisorRequestReservationPost()` */
  static readonly ApiMedicalAdvisorRequestReservationPostPath = '/api/MedicalAdvisor/RequestReservation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMedicalAdvisorRequestReservationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorRequestReservationPost$Response(params?: ApiMedicalAdvisorRequestReservationPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<string | null>> {
    return apiMedicalAdvisorRequestReservationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMedicalAdvisorRequestReservationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorRequestReservationPost(params?: ApiMedicalAdvisorRequestReservationPost$Params, context?: HttpContext): Observable<string | null> {
    return this.apiMedicalAdvisorRequestReservationPost$Response(params, context).pipe(
      map((r: BookingStrictHttpResponse<string | null>): string | null => r.body)
    );
  }

  /** Path part for operation `apiMedicalAdvisorConfirmReservationConfirmReservationPost()` */
  static readonly ApiMedicalAdvisorConfirmReservationConfirmReservationPostPath = '/api/MedicalAdvisor/ConfirmReservation/ConfirmReservation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMedicalAdvisorConfirmReservationConfirmReservationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorConfirmReservationConfirmReservationPost$Response(params?: ApiMedicalAdvisorConfirmReservationConfirmReservationPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<string | null>> {
    return apiMedicalAdvisorConfirmReservationConfirmReservationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMedicalAdvisorConfirmReservationConfirmReservationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorConfirmReservationConfirmReservationPost(params?: ApiMedicalAdvisorConfirmReservationConfirmReservationPost$Params, context?: HttpContext): Observable<string | null> {
    return this.apiMedicalAdvisorConfirmReservationConfirmReservationPost$Response(params, context).pipe(
      map((r: BookingStrictHttpResponse<string | null>): string | null => r.body)
    );
  }

  /** Path part for operation `apiMedicalAdvisorConfirmBookingPost()` */
  static readonly ApiMedicalAdvisorConfirmBookingPostPath = '/api/MedicalAdvisor/ConfirmBooking';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMedicalAdvisorConfirmBookingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorConfirmBookingPost$Response(params?: ApiMedicalAdvisorConfirmBookingPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<string | null>> {
    return apiMedicalAdvisorConfirmBookingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMedicalAdvisorConfirmBookingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorConfirmBookingPost(params?: ApiMedicalAdvisorConfirmBookingPost$Params, context?: HttpContext): Observable<string | null> {
    return this.apiMedicalAdvisorConfirmBookingPost$Response(params, context).pipe(
      map((r: BookingStrictHttpResponse<string | null>): string | null => r.body)
    );
  }

  /** Path part for operation `apiMedicalAdvisorBookingDetailUrnBookingIdGet()` */
  static readonly ApiMedicalAdvisorBookingDetailUrnBookingIdGetPath = '/api/MedicalAdvisor/BookingDetail/{urnBookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMedicalAdvisorBookingDetailUrnBookingIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMedicalAdvisorBookingDetailUrnBookingIdGet$Response(params: ApiMedicalAdvisorBookingDetailUrnBookingIdGet$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<MedicalAdvisorBookingDetailModel>> {
    return apiMedicalAdvisorBookingDetailUrnBookingIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMedicalAdvisorBookingDetailUrnBookingIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMedicalAdvisorBookingDetailUrnBookingIdGet(params: ApiMedicalAdvisorBookingDetailUrnBookingIdGet$Params, context?: HttpContext): Observable<MedicalAdvisorBookingDetailModel> {
    return this.apiMedicalAdvisorBookingDetailUrnBookingIdGet$Response(params, context).pipe(
      map((r: BookingStrictHttpResponse<MedicalAdvisorBookingDetailModel>): MedicalAdvisorBookingDetailModel => r.body)
    );
  }

  /** Path part for operation `apiMedicalAdvisorCancelBookingPost()` */
  static readonly ApiMedicalAdvisorCancelBookingPostPath = '/api/MedicalAdvisor/CancelBooking';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMedicalAdvisorCancelBookingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorCancelBookingPost$Response(params?: ApiMedicalAdvisorCancelBookingPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<void>> {
    return apiMedicalAdvisorCancelBookingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMedicalAdvisorCancelBookingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMedicalAdvisorCancelBookingPost(params?: ApiMedicalAdvisorCancelBookingPost$Params, context?: HttpContext): Observable<void> {
    return this.apiMedicalAdvisorCancelBookingPost$Response(params, context).pipe(
      map((r: BookingStrictHttpResponse<void>): void => r.body)
    );
  }

}
